import React, { useState, useEffect } from "react";
import "./index.scss";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Box, getColor, Icons, Typography } from "fds";
import classNames from "classnames";
import HeaderUserDropdown from "./components/HeaderUserDropdown";
import { getAdminInfoFromLocalStorage } from "./shared/utils/auth";
import { useTranslation } from "react-i18next";
import Home from "./pagesAdmin/Home";
import AdminSetting from "./pagesAdmin/AdminSetting";
import WhiteLabel from "./pagesAdmin/WhiteLabel";
import Position from "./pagesAdmin/Position";
import Trash from "./pagesAdmin/Trash";
import LoginLog from "./pagesAdmin/LoginLog";
import WorkgroupLog from "./pagesAdmin/WorkgroupLog";
import DocLog from "./pagesAdmin/DocLog";
import WorkgroupManage from "./pagesAdmin/Workgroup";
import Config from "./pagesAdmin/Config";
import Dept from "./pagesAdmin/Dept";

function BaseLayoutAdmin() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [tab, changeTab] = useState("/admin/home");
  const [pageReady, setPageReady] = useState(false);

  useEffect(() => {
    changeTab(window.location.pathname);
  }, [window.location.pathname]);

  useEffect(() => {
    if (getAdminInfoFromLocalStorage() === null) {
      window.location.href = `${process.env.PUBLIC_URL}/admin/login`;
    } else {
      setPageReady(true);
    }
  }, [getAdminInfoFromLocalStorage()]);

  const loginResult = getAdminInfoFromLocalStorage();
  const checkAdminMenu = (menu: string): boolean => {
    const allowMenus = loginResult
      ? JSON.parse(loginResult)?.adminPermission?.allowMenus
      : null;
    if (allowMenus) {
      const check = allowMenus.indexOf(menu) > -1;
      return check;
    } else {
      return false;
    }
  };

  const renderHeader = () => {
    return (
      <Box classes="ecoheader">
        <img
          src={require("./shared/images/logo/logo_wrapsody_eco_248.png")}
          alt={"logo"}
          height={32}
          width={129}
        />
        <Box classes="mg ml-auto" alignItems="center">
          <Box classes="ecoheader-profile mg ml-8">
            <HeaderUserDropdown isAdmin={true} />
          </Box>
        </Box>
      </Box>
    );
  };

  const renderSidemenu = () => {
    let tabs = [
      {
        id: "home",
        path: "/admin/home",
        name: t("admin.menu.home"),
        icon: <Icons variant="fill" label="home" />,
      },
    ];

    checkAdminMenu("eco_organ") &&
      tabs.push({
        id: "dept",
        path: "/admin/dept",
        name: t("admin.menu.dept"),
        icon: <Icons variant="fill" label="company" />,
      });

    checkAdminMenu("eco_manage_admin") &&
      tabs.push({
        id: "adminSetting",
        path: "/admin/adminSetting",
        name: t("admin.menu.adminSetting"),
        icon: <Icons variant="fill" label="crown" />,
      });

    checkAdminMenu("eco_manage_admin") &&
      tabs.push({
        id: "whitelabel",
        path: "/admin/whitelabel",
        name: t("admin.menu.whiteLabel"),
        icon: <Icons variant="fill" label="tag" />,
      });

    checkAdminMenu("eco_position_role") &&
      tabs.push({
        id: "position",
        path: "/admin/position",
        name: t("admin.menu.position"),
        icon: <Icons variant="fill" label="briefcase" />,
      });

    checkAdminMenu("eco_workgroup") &&
      tabs.push({
        id: "workgroupManage",
        path: "/admin/workgroupManage",
        name: t("admin.menu.workgroup"),
        icon: <Icons variant="fill" label="users" />,
      });

    checkAdminMenu("eco_common_policy") &&
      tabs.push({
        id: "config",
        path: "/admin/config",
        name: t("admin.menu.config"),
        icon: <Icons variant="fill" label="setting" />,
      });

    checkAdminMenu("eco_doc_usage") &&
      tabs.push({
        id: "docLog",
        path: "/admin/docLog",
        name: t("admin.menu.log"),
        icon: <Icons variant="fill" label="layers" />,
      });

    checkAdminMenu("eco_workgroup_log") &&
      tabs.push({
        id: "workgroupLog",
        path: "/admin/workgroupLog",
        name: t("admin.menu.workgroupLog"),
        icon: <Icons variant="fill" label="log" />,
      });

    checkAdminMenu("eco_login_log") &&
      tabs.push({
        id: "loginLog",
        path: "/admin/loginLog",
        name: t("admin.menu.loginLog"),
        icon: <Icons variant="fill" label="footstep" />,
      });
    checkAdminMenu("eco_storage") &&
      tabs.push({
        id: "storage",
        path: "/admin/storage",
        name: t("admin.menu.storage"),
        icon: <Icons variant="fill" label="graph" />,
      });

    checkAdminMenu("eco_trash") &&
      tabs.push({
        id: "trash",
        path: "/admin/trash",
        name: t("admin.menu.trash"),
        icon: <Icons variant="fill" label="delete" />,
      });

    return (
      <Box classes="sidemenu" id="sidemenuId">
        {tabs.map((item) => (
          <Box
            classes={classNames("sidemenu-button", {
              selected: tab.includes(item.id),
            })}
            onClick={() => navigate(`${process.env.PUBLIC_URL}${item.path}`)}
          >
            {item.icon}
            <Typography
              classes="mg ml-12"
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {item.name}
            </Typography>
          </Box>
        ))}
        <Box classes="mg mt-auto" justifyContent="center" height={14}>
          <Typography
            fontSize={14}
            lineHeight={"14px"}
            fontWeight={400}
            exactColor={"#717985"}
          >
            © Fasoo
          </Typography>
        </Box>
      </Box>
    );
  };

  return pageReady ? (
    <Box direction="column" height="100%">
      {renderHeader()}
      <Box height={"calc(100% - 61px)"}>
        {renderSidemenu()}
        <Box width={"calc(100% - 240px)"} classes="body" id="body">
          <Routes>
            <Route
              id={"home"}
              path={`${process.env.PUBLIC_URL}/home`}
              element={<Home />}
            />
            <Route
              id={"dept"}
              path={`${process.env.PUBLIC_URL}/dept`}
              element={<Dept />}
            />
            <Route
              id={"adminSetting"}
              path={`${process.env.PUBLIC_URL}/adminSetting`}
              element={<AdminSetting />}
            />
            <Route
              id={"whitelabel"}
              path={`${process.env.PUBLIC_URL}/whitelabel`}
              element={<WhiteLabel />}
            />
            <Route
              id={"position"}
              path={`${process.env.PUBLIC_URL}/position`}
              element={<Position />}
            />
            <Route
              id={"workgroupManage"}
              path={`${process.env.PUBLIC_URL}/workgroupManage`}
              element={<WorkgroupManage />}
            />
            <Route
              id={"config"}
              path={`${process.env.PUBLIC_URL}/config`}
              element={<Config />}
            />
            <Route
              id={"docLog"}
              path={`${process.env.PUBLIC_URL}/docLog`}
              element={<DocLog />}
            />
            <Route
              id={"workgroupLog"}
              path={`${process.env.PUBLIC_URL}/workgroupLog`}
              element={<WorkgroupLog />}
            />
            <Route
              id={"loginLog"}
              path={`${process.env.PUBLIC_URL}/loginLog`}
              element={<LoginLog />}
            />
            <Route
              id={"trash"}
              path={`${process.env.PUBLIC_URL}/trash`}
              element={<Trash />}
            />
            <Route
              id={"home"}
              path={`${process.env.PUBLIC_URL}/*`}
              element={<Home />}
            />
          </Routes>
        </Box>
      </Box>
    </Box>
  ) : (
    <Box direction="column" height="100%"></Box>
  );
}

export default BaseLayoutAdmin;
